import React from 'react'
import { FormControl, Button } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import moment from 'moment'
import classNames from 'classnames'

export default class Note extends React.Component {

  constructor(props) {
    super(props)
    this.state = { note: props.note, readonly: props.readonly }
  }

  onChange(e) {
    let note = this.state.note
    note.text = e.target.value
    this.setState({note})
  }

  submit() {
    if (this.state.note.text && this.state.note.text.length > 0) {
      this.props.onSubmit(this.state.note)
      if (this.props.new) {
        this.setState({note: {}})
      } else {
        this.toggleReadonly()
      }
    }
  }

  toggleReadonly() {
    this.setState({readonly: !this.state.readonly})
  }

  render() {
    const { note, readonly } = this.state
    return <div className={classNames('note', {'readonly': readonly})}>
      { !readonly ? <div>
        <FormControl 
          componentClass='textarea' 
          value={note.text || ''} 
          onChange={(e) => this.onChange(e)} 
        />
        <div className='buttons'>
          <Button 
            className='add' 
            onClick={() => this.submit()}>Opslaan
          </Button>
        </div>
      </div>

      : <div>
          <p>{note.text}</p>
          <span className='created-by'>Geplaatst door {note.createdBy} {moment(note.lastModified, ['YYYY', moment.ISO_8601]).format('DD-MM-YYYY HH:mm')}</span>
          <div className='options show'>
            <Button 
              className='edit' 
              onClick={() => this.toggleReadonly()}>Bewerken <FontAwesome name='pencil' />
            </Button>
            <Button 
              className='remove' 
              onClick={() => this.props.onDelete(note)}>Verwijderen <FontAwesome name='times' />
            </Button>
          </div>
      </div> }
    </div>
  }
}
